import { render, staticRenderFns } from "./ActorCard.vue?vue&type=template&id=4961966b&scoped=true&"
import script from "./ActorCard.vue?vue&type=script&lang=js&"
export * from "./ActorCard.vue?vue&type=script&lang=js&"
import style0 from "./ActorCard.vue?vue&type=style&index=0&id=4961966b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4961966b",
  null
  
)

export default component.exports